import React from "react";

const Documentation = () => {
  return (
    <div className="flex items-center justify-center h-screen text-5xl font-semibold text-[#273c75]">
      <h1>COMING SOON</h1>
    </div>
  );
};

export default Documentation;
